import { PENDING_NOTIFICATION } from '../actions/const';

const initialState = {
  resetState: false,
  showModal: false,
  isLoadingAction: false,
  isUploadingCSVFile: false,

  selectedData: null,
  formType: "",
  formId: "",
  formTitle: "",

  sendMode: {
		value: "TEST",
		label: "TEST"
	},
	sendModeOptions: [
		{
			value: "TEST",
			label: "TEST"
		},
		{
			value: "LIVE",
			label: "LIVE"
		},
	],
  userType: {
		value: 'MEMBER',
		label: 'MEMBER'
	},
	userTypeOptions: [
		{
			value: 'ALL',
			label: 'ALL'
		}, {
			value: 'MEMBER',
			label: 'MEMBER'
		}, {
			value: 'NON-MEMBER',
			label: 'NON-MEMBER'
		}
	],
	cardType: [],
	cardTypeOptions: [],
	ageBracket: [35, 45],
	gender: null,
  genderOptions: [
		{
			value: 'ALL',
			label: 'All'
		}, {
			value: 'MALE',
			label: 'Male'
		}, {
			value: 'FEMALE',
			label: 'Female'
		}
	],
	device: {
		value: 'ALL',
		label: 'ALL'
	},
	deviceOptions: [
		{
			value: 'ALL',
			label: 'ALL'
		}, {
			value: 'ANDROID',
			label: 'ANDROID'
		}, {
			value: 'IOS',
			label: 'IOS'
		}
	],
	screen: null,
	screenOptions: [],
	browser: null,
	browserOptions: [
		{
			value: 'INTERNAL',
			label: 'INTERNAL'
		}, {
			value: 'EXTERNAL',
			label: 'EXTERNAL'
		}
	],
	specificUser: [],
	specificUserOptions: [],
	blacklistedUser: [],
	blacklistedUserOptions: [],

  subject: "",
	url: "",
	message: "",
	isSendNow: true,
	scheduleDateTimeNotif: ""
};

function reducer (state = initialState, action) {
  let {type, payload} = action;

  switch (type) {
    case PENDING_NOTIFICATION:
    if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
      action.payload = {...initialState};
    }
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/PendingNotification.js